<template>
  <v-list-item-content style="flex-basis: 100%;">
    <v-list-item-title> {{ data.item.name }}</v-list-item-title>
    <v-list-item-subtitle :class="{ 'text-disabled': isItemDisabled }">
      {{ data.item.formatted_address }}
    </v-list-item-subtitle>
  </v-list-item-content>
</template>

<script>
import { BUSINESS_TYPE } from "@/enums/business-type.enum";
export default {
  name: "SelectBusinessAddress",
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    isItemDisabled() {
      return this.data.item.business_type === BUSINESS_TYPE.AREA;
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .text-disabled {
  color: $gray-2 !important;
}
</style>
